import { SidebarSection } from '../models/sidebar-section.model';

export interface UIState {
  isSidebarOpen: boolean;
  sidebarItems: SidebarSection[];
  isLoading: boolean; // For global loading indicators
}

export const initialUIState: UIState = {
  isSidebarOpen: false, // Closed by default for mobile
  sidebarItems: [],
  isLoading: false,
};
